<template>
  <Dialog
    v-model="dialogValue"
    v-bind="$attrs"
    :persistent="dataLoading"
  >
    <template
      v-if="dataLoading"
      #content
    >
      <div class="text-center">
        <v-progress-circular
          indeterminate
          color="primary"
        />
      </div>
    </template>
    <template
      v-else
      #content
    >
      <OrderConsentDownload />
    </template>

    <template #actions>
      <Button
        :label="$t('Close')"
        color="primary"
        class="text-white"
        @click="dialogValue = false"
      />
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import Dialog from "@/components/dialogs/Dialog";
import Button from "@/components/input-components/Button.vue";
import OrderConsentDownload from "@/components/orders/OrderConsentDownload.vue";

defineOptions({
  name: 'PatientCreation'
})

// props
const props = defineProps<{
  dataLoading: boolean
  modelValue: boolean
}>()

// emits
const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
}>()

const dialogValue = computed({
  get: () => props.modelValue,
  set: (val: boolean) => emit('update:modelValue', val),
})
</script>
